/*
 * File: d:\projects\AutoFiFront\src\Content\Home\HomeCardHolder\HomeCardHolder.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday February 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 6th November 2023 11:01:01
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useEffect, useState, Fragment, MouseEvent } from 'react';
import { NavLink } from 'react-router-dom';
import styles from 'Content/Home/HomeCardHolder/HomeCardHolder.module.css';
import CarSlider from 'Content/Home/HomeCarSlider/HomeCarSlider';
import AboutUs from 'Content/Home/HomeAboutUs/HomeAboutUs';
import TextCardWrapper from 'Content/Home/TextCardWrapper/TextCardWrapper';
import { BsFillTelephoneInboundFill as Phone } from "react-icons/bs";
import { MdMail } from "react-icons/md";
import { useMyContext } from "Content/Main/Main";
import translator from 'MultiLanguage/TranslationWrapper';
import RouterPathResolver from 'Config/Router/RouterPathResolver';
import Transparency from 'Content/SVG/EngagementSVG/Transparency';
import Knowledge from 'Content/SVG/EngagementSVG/Knowledge';
import Serenity from 'Content/SVG/EngagementSVG/Serenity';
import Price from 'Content/SVG/EngagementSVG/Price';
import { FaCalculator } from "react-icons/fa";
import TruckSVG from 'Content/SVG/Truck';
import { MdOutlineMenuBook } from "react-icons/md";
import { FaFileContract } from "react-icons/fa6";
import { FaUserEdit } from "react-icons/fa";
import HomeTitle from '../HomeTitle/HomeTitle';
import ModalPhone from 'Content/Modals/ModalPhone/ModalPhone';

function HomeCardHolder() {
    const [modalCta, setModalCta] = useState(false);

    const engagementsArray = [
        {
            title:"knowledge",
            text:"knowledgeText",
            icon:<Knowledge fill={"var(--theme-color)"} />
        },
        {
            title:"transparency",
            text:"transparencyText",
            icon:<Transparency fill={"var(--theme-color)"} />
        },
        {
            title:"serenity",
            text:"serenityText",
            icon:<Serenity fill={"var(--theme-color)"} />
        },
        {
            title:"price",
            text:"priceText",
            icon:<Price fill={"var(--theme-color)"} />
        }
    ];

    const processArray = [
        {
            title:"subscribe",
            text:"subscribeText",
            icon:<FaUserEdit size="5rem" fill={"var(--theme-color)"} />
        },
        {
            title:"stock",
            text:"stockText",
            icon:<MdOutlineMenuBook size="5rem" fill={"var(--theme-color)"} />
        },
        {
            title:"offer",
            text:"offerText",
            icon:<FaFileContract size="3rem" fill={"var(--theme-color)"} />
        },
        {
            title:"study",
            text:"studyText",
            icon:<FaCalculator size="3rem" fill={"var(--theme-color)"} />
        },
        {
            title:"delivery",
            text:"deliveryText",
            icon:<TruckSVG width='10rem' fill={"var(--theme-color)"} />
        },
    ];

    const { setterThemeColor } = useMyContext();
    useEffect(()=>{
        setterThemeColor("");
    }, []);

    const handleToggleCtaModal = (e: MouseEvent<HTMLElement>) => {
        setModalCta(false);
    };

    return(
        <Fragment>
            <div className={`${styles.homeHolder}`}>
                <HomeTitle />
                <div className={`${styles.secI}`}>
                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.ourSelection")}</h2>
                    <CarSlider isPromo={true} orderList={{name:"id", order:"desc"}}/>
                </div>
                <div className={`${styles.secII}`}>
                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.aboutUs")}</h2>
                    <AboutUs translate={true} imgDisplay={true} btnDisplay={true} bgColor={"var(--theme-bg-color)"} color={"var(--text-color-first)"} text={"home.aboutUsText"}/>
                </div>
                <div className={`${styles.secII}`}>
                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.ourEngagements")}</h2>
                    <TextCardWrapper arrowLink={false} goto={RouterPathResolver.routeAbout.path} itemsArray={engagementsArray} />
                </div>
                <div className={`${styles.secII}`}>
                    <h2 className={`${styles.sectionTitle}`}>{translator.decode("home.ourProcess")}</h2>
                    <TextCardWrapper arrowLink={true} itemsArray={processArray}/>
                </div>
            </div>
            <div className={`${styles.btnContact}`}>
                <button className={`${styles.btnPhone}`} onClick={()=> setModalCta(true)} ><Phone size={"1.5rem"}/>{translator.decode("home.callBack")}</button>
                <NavLink to={RouterPathResolver.routeContact.path} className={`${styles.btnPhone}`}><MdMail size={"1.5rem"}/>{translator.decode("home.contact")}</NavLink>
            </div>
            <ModalPhone show={modalCta} onClose={handleToggleCtaModal} closeModal={handleToggleCtaModal} themeColor={"themeColor"}/>
        </Fragment>
    );
}

export default HomeCardHolder;
